import { defineComponent as f, createBlock as m, openBlock as r, unref as s, withCtx as c, createElementVNode as u, normalizeClass as d, createVNode as o, createElementBlock as l, Fragment as i, createTextVNode as p, renderList as b } from "vue";
import { Disclosure as v, DisclosureButton as _, DisclosurePanel as k } from "@headlessui/vue";
import { ScalarIcon as B } from "@scalar/components";
import H from "../../../components/Content/Schema/SchemaProperty.vue.js";
const V = /* @__PURE__ */ f({
  __name: "ParameterHeaders",
  props: {
    headers: {},
    breadcrumb: {}
  },
  setup(S) {
    function h(e) {
      return e.schema !== void 0;
    }
    return (e, y) => (r(), m(s(v), null, {
      default: c(({ open: a }) => [
        u("div", {
          class: d(["headers-card headers-card--compact", [{ "headers-card--open": a }]])
        }, [
          u("div", {
            class: d(["headers-properties", { "headers-properties-open": a }])
          }, [
            o(s(_), {
              class: "headers-card-title headers-card-title--compact",
              style: {
                top: "calc(var(--refs-header-height)))"
              }
            }, {
              default: c(() => [
                o(s(B), {
                  class: d(["headers-card-title-icon", { "headers-card-title-icon--open": a }]),
                  icon: "Add",
                  size: "sm"
                }, null, 8, ["class"]),
                a ? (r(), l(i, { key: 0 }, [
                  p(" Hide Headers ")
                ], 64)) : (r(), l(i, { key: 1 }, [
                  p(" Show Headers ")
                ], 64))
              ]),
              _: 2
            }, 1024),
            o(s(k), null, {
              default: c(() => [
                (r(!0), l(i, null, b(e.headers, (t, n) => (r(), m(H, {
                  breadcrumb: e.breadcrumb ? [...e.breadcrumb, "headers"] : void 0,
                  key: n,
                  description: t.description,
                  name: `${n}`,
                  value: h(t) ? t.schema : void 0
                }, null, 8, ["breadcrumb", "description", "name", "value"]))), 128))
              ]),
              _: 1
            })
          ], 2)
        ], 2)
      ]),
      _: 1
    }));
  }
});
export {
  V as default
};
